import { api } from "@/features/utils/fetch-server";
import type { Voice } from "../types";

export class VoicesAPI {
  static async list(clientId: string): Promise<{ voices: Voice[] }> {
    return api.get(`/api/configuration/v1/${clientId}/voices`);
  }

  // Provider names (elevenlabs / openai / mistral) whose voices can actually be
  // synthesized on this deployment — used to hide voices we have no credentials for.
  static async listProviders(
    clientId: string,
  ): Promise<{ providers: string[] }> {
    return api.get(`/api/configuration/v1/${clientId}/voice-providers`);
  }

  // The voice's preview in a temperament and a language: synthesized on the first request,
  // cached server-side after that. Returns the S3 key the public files route serves.
  static async sample(
    clientId: string,
    voiceId: string,
    temperament: string,
    language: string,
  ): Promise<{ sample: string }> {
    const query = new URLSearchParams({ temperament, language });
    return api.get(
      `/api/configuration/v1/${clientId}/voices/${voiceId}/sample?${query}`,
    );
  }
}
